import * as React from 'react'

import { inject, observer } from 'mobx-react'

import LinkedWorkflowRestriction from '~/client/src/desktop/views/ProjectSetUp/components/PermitsSetUp/components/FieldConfigurator/components/WorkflowFieldRestriction/variants/LinkedWorkflowRestriction'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import StruxhubInputLabel from '~/client/src/shared/components/StruxhubInputs/components/StruxhubInputLabel'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import WorkflowTypesStore from '~/client/src/shared/stores/domain/WorkflowTypes.store'
import { areArraysEqualUnordered } from '~/client/src/shared/utils/util'

// localization: translated

interface IProps {
  workflowTypes: string[]
  onChange: (workflowTypes: string[]) => void
  onClose: () => void
  workflowTypesStore?: WorkflowTypesStore
}

const RestrictionEditor: React.FC<IProps> = ({
  workflowTypes,
  onChange,
  onClose,
  workflowTypesStore,
}) => {
  const [selectedTypes, setSelectedTypes] = React.useState<string[]>([])

  React.useEffect(() => {
    setSelectedTypes([...workflowTypes])
  }, [workflowTypes])

  const permitTypes = React.useMemo(() => {
    const types = selectedTypes
      .map(type => workflowTypesStore.getLastUpdatedTypeByType(type))
      .filter(Boolean)
    return !types.length ? workflowTypesStore.actualTypes : types
  }, [selectedTypes, workflowTypesStore])

  const handleSelectionChange = React.useCallback(
    (selectedTypes: string[]) => {
      const newSelectedTypes = selectedTypes
        .map(type => workflowTypesStore.getActualTypeByType(type))
        .filter(Boolean)
        .map(type => type.type)
      const allTypes = workflowTypesStore.actualTypes.map(pt => pt.type)

      if (areArraysEqualUnordered(newSelectedTypes, allTypes)) {
        setSelectedTypes([])
      } else {
        setSelectedTypes(newSelectedTypes)
      }
    },
    [workflowTypesStore],
  )

  const saveChanges = React.useCallback(() => {
    if (!areArraysEqualUnordered(selectedTypes, workflowTypes)) {
      onChange(selectedTypes)
    }
  }, [selectedTypes, workflowTypes, onChange])

  return (
    <div className="bg-white py12 w360">
      <div className="pb12 px16 bb-light-input-border">
        <StruxhubInputLabel
          isValid
          isRequired
          isRequiredTextHidden
          label={Localization.translator.appliedTo(permitTypes.length)}
          value="1"
        />
        <LinkedWorkflowRestriction
          selectedTypes={permitTypes}
          allTypes={workflowTypesStore.actualTypes}
          onSelectionChange={handleSelectionChange}
        />
      </div>
      <div className="tw:flex tw:items-center pt12 bg-white tw:justify-end px16">
        <Button
          variant="primary-outline"
          className="brada100 h40 px24 mr8"
          onClick={onClose}
        >
          {Localization.translator.cancel}
        </Button>
        <Button
          variant="default"
          className="brada100 h40 px24"
          onClick={() => {
            saveChanges()
            onClose()
          }}
        >
          {Localization.translator.save}
        </Button>
      </div>
    </div>
  )
}

export default inject('workflowTypesStore')(observer(RestrictionEditor))
